export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            有爆料线索？有合作意向？欢迎通过以下方式与我们取得联系
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
                <i className="ri-mail-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading whitespace-nowrap">
                爆料投稿
              </h3>
              <p className="text-sm text-foreground-600 mb-3">
                有独家线索？欢迎投稿
              </p>
              <span className="text-sm text-primary-600 font-medium whitespace-nowrap">
                tips@51baoliao.com
              </span>
            </div>

            <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-briefcase-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading whitespace-nowrap">
                商务合作
              </h3>
              <p className="text-sm text-foreground-600 mb-3">
                广告投放与品牌合作
              </p>
              <span className="text-sm text-accent-600 font-medium whitespace-nowrap">
                biz@51baoliao.com
              </span>
            </div>

            <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
              <div className="w-14 h-14 mx-auto rounded-2xl bg-secondary-100 flex items-center justify-center mb-4">
                <i className="ri-question-answer-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading whitespace-nowrap">
                用户反馈
              </h3>
              <p className="text-sm text-foreground-600 mb-3">
                问题反馈与功能建议
              </p>
              <span className="text-sm text-secondary-600 font-medium whitespace-nowrap">
                feedback@51baoliao.com
              </span>
            </div>
          </div>

          <div className="mt-8 p-6 rounded-xl bg-background-100 border border-background-200/60">
            <p className="text-sm text-foreground-600 leading-relaxed">
              你也可以通过微信公众号 <strong className="text-foreground-900">51爆料每日大赛</strong> 或微博{' '}
              <strong className="text-foreground-900">@51爆料官方</strong> 关注我们的最新动态。
              稿件审核周期为 1-3 个工作日，商务合作将在 24 小时内回复。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}